import axios from "axios";
import CreateSetupBackend from "./config/config.js";

let SetupBackend = null;

function getQuoteDays(coin, amount) {
  SetupBackend = CreateSetupBackend();

  /*
    ── O e-mail vai na query, e não é enredo: é o que destrava o 401 ──

    A validação de token do BaaS cruza os e-mails encontrados na requisição com o do token, e
    RECUSA quando não encontra nenhum ("Nenhum email encontrado na requisição para validar
    token BaaS"). A rota de cotação é `quote/{moeda}/{quantidade}` — não tem e-mail em lugar
    nenhum, então caía em 401 depois de o 404 ser consertado.

    A cotação não é dado de cliente: é preço público de mercado. O e-mail não seleciona nada
    aqui, serve só para o cruzamento ter o que comparar — e mantê-lo é melhor que abrir a rota,
    que a deixaria como proxy público para a API de terceiro.
  */
  const email = sessionStorage.getItem("emailUser") || "";
  const query = email ? `?email=${encodeURIComponent(email)}` : "";

  /*
    As duas rotas são do MESMO controller na API, então esta segunda tentativa nunca foi
    alternativa para a primeira: quando uma respondia 404, a outra respondia igual. Foi o
    que aconteceu — o controller ficava de fora da lista de controllers de BaaS que o
    middleware deixa responder, e as quatro moedas caíam juntas.

    As duas continuam aqui porque são caminhos publicados e há clientes em versões
    diferentes; o que mudou é a expectativa: elas cobrem divergência de ROTA, não
    indisponibilidade. Para indisponibilidade quem responde é a reserva do lado do
    servidor, que é onde ela tem como existir.
  */
  return SetupBackend.get(`/v1/baas/util/quote/${coin}/${amount}${query}`).catch(() =>
    SetupBackend.get(`/v1/pix/util/quote/${coin}/${amount}${query}`),
  );
}

function getStockMarket() {
  // A chave da RapidAPI estava aqui em texto puro, indo para o bundle. Agora a
  // chamada é de mesma origem e o nginx injeta a chave (ver nginx.conf.template).
  return axios.request({
    method: "GET",
    url: "/proxy/rapidapi/market-trends",
    params: {
      trend_type: "MOST_ACTIVE",
      country: "br",
      language: "pt",
    },
  });
}

const QuoteService = {
  getQuoteDays,
  getStockMarket,
};

export default QuoteService;
